import { render, staticRenderFns } from "./ApprovalTypeField.vue?vue&type=template&id=43b13942"
import script from "./ApprovalTypeField.vue?vue&type=script&lang=js"
export * from "./ApprovalTypeField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports